import { type DefaultTheme } from 'styled-components'

export type AvatarSize = 'small' | 'medium' | 'large'

export const AVATAR_SIZES: Record<
  AvatarSize,
  {
    diameterPx: number
    fontSizeToken: keyof DefaultTheme['fontSizes']
    fontWeightToken: keyof DefaultTheme['fontWeights']
    lineHeightPx: number
  }
> = {
  small: {
    diameterPx: 32,
    fontSizeToken: 'body2',
    fontWeightToken: 'semibold',
    lineHeightPx: 12,
  },
  medium: {
    diameterPx: 36,
    fontSizeToken: 'body1',
    fontWeightToken: 'semibold',
    lineHeightPx: 14,
  },
  large: {
    diameterPx: 40,
    fontSizeToken: 'body1',
    fontWeightToken: 'bold',
    lineHeightPx: 24,
  },
}
